import { render, staticRenderFns } from "./cpCreate.vue?vue&type=template&id=699b24dc&scoped=true&"
import script from "./cpCreate.vue?vue&type=script&lang=js&"
export * from "./cpCreate.vue?vue&type=script&lang=js&"
import style0 from "./cpCreate.vue?vue&type=style&index=0&id=699b24dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "699b24dc",
  null
  
)

export default component.exports